import React from 'react';
import Maintenance from '../../../components/Errors/Maintenance';

const MaintenancePage = () => {
  return <Maintenance />;
};

export default MaintenancePage;
